import { useState } from "react";

function Question({question, answer}) {

    const [open, setOpen] = useState(false)

    return (
        <>
        <div style={({display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between", width: "100%"})}>
          <h3 style={({color: "rgb(30,30,30)", fontSize: "15px", fontWeight: "bold"})}>{question}</h3>
          <img src="arrow.png" style={({width: "30px", height: "30px", cursor: "pointer", transform: open ? "rotate(180deg)" : "rotate(0deg)"})} onClick={() => setOpen(!open)} />
        </div>
        {open && (
          <div style={({color: "rgb(30,30,30)", fontSize: "13px", textAlign: "left", width: "100%"})}>
            {answer}
          </div>
        )}
        </>
    );
  }
  
  export default Question;